//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'caseList',
  data () {
    return {
      caseListType: ''
    }
  },
  methods: {
    goSearch () {
      if (this.$route.name === 'DzdCaseList') {
        this.caseListType = 1
      } else if (this.$route.name === 'YzdCaseList') {
        this.caseListType = 2
      } else if (this.$route.name === 'MedicalUnionList') {
        this.caseListType = 3
      }
      this.$router.push({path: '/casesearch/' + this.caseListType})
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/doctor/caselist/caseList.vue